import { SERVICE_CODE_OPTIONS } from 'shared/constants/serviceCodes';

export const PERMISSIONS = Object.freeze({
  administration: {
    tenantAdmin: 'TENANT_ADMIN',
  },

  authentication: {
    signIn: 'AUTH_SIGN_IN',
    signOut: 'AUTH_SIGN_OUT',
    getUser: 'AUTH_GET_USER',
    sessionContext: 'AUTH_SESSION_CONTEXT',
    refreshToken: 'AUTH_REFRESH_TOKEN',
  },

  tenantUsers: {
    list: 'TENANT_USERS_LIST',
    get: 'TENANT_USERS_GET',
    status: 'TENANT_USERS_STATUS',
  },

  users: {
    resetPassword: 'USERS_RESET_PASSWORD',
    signUp: 'USERS_SIGN_UP',
    newPassword: 'USERS_NEW_PASSWORD',
    changePassword: 'USERS_CHANGE_PASSWORD',
    update: 'USERS_UPDATE',
    getUser: 'USERS_GET_USER',
    getUsers: 'USERS_GET_USERS',
    status: 'USERS_STATUS',
    rotateStatus: 'USERS_ROTATE_STATUS',
    uploadFile: 'USERS_UPLOAD_FILE',
  },

  files: {
    photo: 'FILES_PHOTO',
    tenantLogo: 'FILES_TENANT_LOGO',
  },

  sessions: {
    getUserSessions: 'SESSIONS_GET_USER_SESSIONS',
  },

  groups: {
    list: 'GROUPS_LIST',
    status: 'GROUPS_STATUS',
  },

  permissions: {
    list: 'PERMISSIONS_LIST',
    status: 'PERMISSIONS_STATUS',
  },

  contract: {
    performContract: 'PERFORM_CONTRACT',
  },

  payroll: {
    performPayroll: 'PERFORM_PAYROLL',
  },

  systemRegister: {
    perform: 'PERFORM_SYSTEM_REGISTER',
    viewSystems: 'VIEW_IT_GOVERNANCE_SYSTEMS',
    viewSystemDetails: 'VIEW_IT_GOVERNANCE_SYSTEM_DETAILS',
    viewRiskRegister: 'VIEW_IT_GOVERNANCE_RISK_REGISTER',
    viewAssetRegister: 'VIEW_IT_GOVERNANCE_ASSET_REGISTER',
    viewSop: 'VIEW_IT_GOVERNANCE_SOP',
    viewChangeManagement: 'VIEW_IT_GOVERNANCE_CHANGE_MANAGEMENT',
    viewMonitoringReview: 'VIEW_IT_GOVERNANCE_MONITORING_REVIEW',
    viewIncidentManagement: 'VIEW_IT_GOVERNANCE_INCIDENT_MANAGEMENT',
    viewAccessProvision: 'VIEW_IT_GOVERNANCE_ACCESS_PROVISION',
    firstAccessProvisionApproval: 'PERFORM_FIRST_ACCESS_PROVISION_APPROVAL',
    secondAccessProvisionApproval: 'PERFORM_SECOND_ACCESS_PROVISION_APPROVAL',
    testPermission: 'TEST_PERMISSION',
  },

});

export const TENANT_ADMIN_PERMISSION = PERMISSIONS.administration.tenantAdmin;

export { SERVICE_CODE_OPTIONS };

export const PERMISSION_ACTIVITY_ORDER = Object.freeze([
  'Payroll',
  'Contract',
  'Systems',
  'Risk register',
  'IT asset register',
  'SOP',
  'Change management',
  'Monitoring and review',
  'Incident management',
  'Access provision',
  'Other',
]);

export const PERMISSION_OPTIONS = Object.freeze([
  {
    label: 'Perform payroll',
    permission: PERMISSIONS.payroll.performPayroll,
    serviceCode: '111',
    activity: 'Payroll',
  },
  {
    label: 'Perform contract',
    permission: PERMISSIONS.contract.performContract,
    serviceCode: '222',
    activity: 'Contract',
  },
  {
    label: 'Perform system register',
    permission: PERMISSIONS.systemRegister.perform,
    serviceCode: '333',
    activity: 'Systems',
  },
  {
    label: 'View IT Governance add and view all systems',
    permission: PERMISSIONS.systemRegister.viewSystems,
    serviceCode: '333',
    activity: 'Systems',
  },
  {
    label: 'View IT Governance manage system details',
    permission: PERMISSIONS.systemRegister.viewSystemDetails,
    serviceCode: '333',
    activity: 'Systems',
  },
  {
    label: 'Perform first system approval',
    permission: 'PERFORM_FIRST_SYSTEM_APPROVAL',
    serviceCode: '333',
    activity: 'Systems',
  },
  {
    label: 'Perform second system approval',
    permission: 'PERFORM_SECOND_SYSTEM_APPROVAL',
    serviceCode: '333',
    activity: 'Systems',
  },
  {
    label: 'View IT Governance risk register',
    permission: PERMISSIONS.systemRegister.viewRiskRegister,
    serviceCode: '333',
    activity: 'Risk register',
  },
  {
    label: 'View IT Governance IT asset register',
    permission: PERMISSIONS.systemRegister.viewAssetRegister,
    serviceCode: '333',
    activity: 'IT asset register',
  },
  {
    label: 'View IT Governance SOP',
    permission: PERMISSIONS.systemRegister.viewSop,
    serviceCode: '333',
    activity: 'SOP',
  },
  {
    label: 'View IT Governance change management',
    permission: PERMISSIONS.systemRegister.viewChangeManagement,
    serviceCode: '333',
    activity: 'Change management',
  },
  {
    label: 'Perform system register change management first approval',
    permission: 'PERFORM_FIRST_CHANGE_APPROVAL',
    serviceCode: '333',
    activity: 'Change management',
  },
  {
    label: 'Perform system register change management second approval',
    permission: 'PERFORM_SECOND_CHANGE_APPROVAL',
    serviceCode: '333',
    activity: 'Change management',
  },
  {
    label: 'View IT Governance monitoring and review',
    permission: PERMISSIONS.systemRegister.viewMonitoringReview,
    serviceCode: '333',
    activity: 'Monitoring and review',
  },
  {
    label: 'Perform system register review management first approval',
    permission: 'PERFORM_FIRST_REVIEW_APPROVAL',
    serviceCode: '333',
    activity: 'Monitoring and review',
  },
  {
    label: 'Perform system register review management second approval',
    permission: 'PERFORM_SECOND_REVIEW_APPROVAL',
    serviceCode: '333',
    activity: 'Monitoring and review',
  },
  {
    label: 'View IT Governance incident management',
    permission: PERMISSIONS.systemRegister.viewIncidentManagement,
    serviceCode: '333',
    activity: 'Incident management',
  },
  {
    label: 'Perform system register incident management first approval',
    permission: 'PERFORM_FIRST_INCIDENT_APPROVAL',
    serviceCode: '333',
    activity: 'Incident management',
  },
  {
    label: 'Perform system register incident management second approval',
    permission: 'PERFORM_SECOND_INCIDENT_APPROVAL',
    serviceCode: '333',
    activity: 'Incident management',
  },
  {
    label: 'View IT Governance access provision',
    permission: PERMISSIONS.systemRegister.viewAccessProvision,
    serviceCode: '333',
    activity: 'Access provision',
  },
  {
    label: 'Perform system register access provision first approval',
    permission: PERMISSIONS.systemRegister.firstAccessProvisionApproval,
    serviceCode: '333',
    activity: 'Access provision',
  },
  {
    label: 'Perform system register access provision second approval',
    permission: PERMISSIONS.systemRegister.secondAccessProvisionApproval,
    serviceCode: '333',
    activity: 'Access provision',
  },
]);

/**
 * Flatten all permission values into one array
 */
function extractPermissions(obj) {
  return Object.values(obj).flatMap((value) => {
    if (typeof value === 'object' && value !== null) {
      return extractPermissions(value);
    }
    return value;
  });
}

export const ALL_PERMISSION_KEYS = Object.freeze(
  extractPermissions(PERMISSIONS)
);

export function isKnownPermissionKey(code) {
  if (code == null) return false;

  const normalized = String(code).trim().toUpperCase();

  return ALL_PERMISSION_KEYS.includes(normalized);
}

export function resolvePermissionActivity(permissionKey) {
  if (permissionKey == null) return 'Other';
  const normalized = String(permissionKey).trim().toUpperCase();
  const match = PERMISSION_OPTIONS.find((option) => option.permission === normalized);
  return match?.activity || 'Other';
}

function permissionActionRank(permissionKey) {
  const key = String(permissionKey ?? '').toUpperCase();
  if (key.startsWith('VIEW_')) return 0;
  if (key.startsWith('PERFORM_FIRST_')) return 2;
  if (key.startsWith('PERFORM_SECOND_')) return 3;
  if (key.startsWith('PERFORM_')) return 1;
  return 4;
}

export function comparePermissionsByActivity(aKey, bKey) {
  const aActivity = resolvePermissionActivity(aKey);
  const bActivity = resolvePermissionActivity(bKey);
  const aOrder = PERMISSION_ACTIVITY_ORDER.indexOf(aActivity);
  const bOrder = PERMISSION_ACTIVITY_ORDER.indexOf(bActivity);
  const activityCmp = (aOrder < 0 ? 99 : aOrder) - (bOrder < 0 ? 99 : bOrder);
  if (activityCmp !== 0) return activityCmp;
  const actionCmp = permissionActionRank(aKey) - permissionActionRank(bKey);
  if (actionCmp !== 0) return actionCmp;
  return String(aKey ?? '').localeCompare(String(bKey ?? ''));
}

export function resolvePermissionServiceCode(permissionKey) {
  if (permissionKey == null) return '';
  const normalized = String(permissionKey).trim().toUpperCase();
  const match = PERMISSION_OPTIONS.find((option) => option.permission === normalized);
  return match?.serviceCode ?? '';
}

export function resolveServiceLabel(serviceCode) {
  if (serviceCode == null) return '';
  const normalized = String(serviceCode).trim();
  const match = SERVICE_CODE_OPTIONS.find((option) => option.value === normalized);
  return match?.label ?? normalized;
}

/** Tenant-assigned service codes from GET /auth/context ({@code serviceCodes}). */
export function profileTenantServiceCodes(profile) {
  if (!profile || !Array.isArray(profile.serviceCodes)) return [];
  return profile.serviceCodes.map((s) => String(s).trim()).filter(Boolean);
}

export function profileHasTenantServiceCode(profile, serviceCode) {
  const needle = String(serviceCode ?? '').trim();
  if (!needle) return false;
  return profileTenantServiceCodes(profile).includes(needle);
}

export default PERMISSIONS;